module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canis_minor/cmi_figure-059eefccb5bef8e98e8a95b2a379ee0f.gif";